// "Keep me signed in on this device" preference.
//
// The default auth posture (see amplifyConfig.js) stores Cognito tokens in
// sessionStorage, which is wiped when the browser/tab closes, so a returning
// user re-OTPs. This module lets a learner OPT IN to the longer-lived
// localStorage path on a device they own.
//
// The choice is a single non-sensitive boolean; it always lives in localStorage
// (it must survive the browser close it is meant to opt into). When set, both
// the Amplify tokens AND the App.js `userSession` blob go to localStorage, so a
// returning user is restored without a re-OTP up to the refresh token's ~30-day
// lifetime.

const REMEMBER_KEY = "rememberDevice";

/** True if the user opted to stay signed in on this device. */
export const getRememberDevice = () => {
  try {
    return window.localStorage.getItem(REMEMBER_KEY) === "true";
  } catch {
    // Private-mode / storage-disabled browsers: treat as not-remembered.
    return false;
  }
};

/** Persist (or clear) the opt-in. Call before starting the OTP challenge. */
export const setRememberDevice = (remember) => {
  try {
    if (remember) {
      window.localStorage.setItem(REMEMBER_KEY, "true");
    } else {
      window.localStorage.removeItem(REMEMBER_KEY);
    }
  } catch {
    /* storage unavailable — non-remembered is the safe fallback */
  }
};

/**
 * The Web Storage backend for the app-session blob, matching where the Cognito
 * tokens live: localStorage when remembered, else sessionStorage. Keeping the
 * two in the same store means a restore never finds tokens without a session
 * blob (or vice versa).
 */
export const sessionBackend = () =>
  getRememberDevice() ? window.localStorage : window.sessionStorage;
